import * as React from "react";
import {Label} from "bloomer";
import InputWarning from "../../../../../elements/InputWarning";

interface ISpeechRecognitionModelInputState {
    file: any;
    fileErrorMessage: string;
}

interface ISpeechRecognitionModelInputProps {
    showUserInputsOnly?: boolean;
}

class SpeechRecognitionModelInput extends React.Component<ISpeechRecognitionModelInputProps, ISpeechRecognitionModelInputState> {
    constructor(props: ISpeechRecognitionModelInputProps) {
        super(props);

        this.state = {
            file: null,
            fileErrorMessage: "",
        };
    }

    public handleFileChange = (e: any) => {
        this.setState({
            fileErrorMessage: ""
        });

        const file = e.target.files[0];
        if (file) {
            if (file.name.endsWith('.wav')) {
                this.setState({
                    file
                });
            } else {
                this.setState({
                    file: null,
                    fileErrorMessage: "The model only accepts wav format files. Please upload wav file."
                });
            }
        }
    };

    public validateForm = () => {
        if (!this.state.file) {
            this.setState({
                fileErrorMessage: "Please select file."
            });
            return false;
        }
        return true;
    };

    public getFormData = (modelNamePrefix: string) => {
        const data = {
            audio_data: this.state.file,
            language_code: "en-US",
            media_format: "wav"
        };

        const formData = new FormData();
        Object.keys(data).forEach((key: string) => {
            formData.append(`${modelNamePrefix}.${key}`, data[key]);
        });
        return formData;
    };

    public resetForm = () => {
        this.setState({
            file: null,
            fileErrorMessage: ""
        });
    };

    public render() {
        return (
            <React.Fragment>
                <Label>Select Audio File as Input:</Label>
                <input
                    accept=".wav"
                    type="file"
                    onChange={this.handleFileChange}
                />
                {
                    this.state.fileErrorMessage && <div>
                        <InputWarning>{this.state.fileErrorMessage}</InputWarning>
                    </div>
                }
            </React.Fragment>
        );
    }
}

export default SpeechRecognitionModelInput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/input/SpeechRecognition/SpeechRecognitionModelInput.tsx